import Enum from 'enum';

export const main = new Enum(
    [
        'BE2',
        'PSI',
        'POS',
        'SCM',
        'KATALYST',
    ],
    {freeze: true}
);

export const enumToCode = enumItem => (
    !enumItem || !main.isDefined(enumItem) ?
        undefined :
        enumItem.key.toLowerCase()
);

export const codeToEnum = code => (
    code === undefined ?
        undefined :
        main.get(code.toUpperCase())
);
